export default {
  payWelfareText: 'Phúc Lợi Nạp',
  blackFridayDiscount: 'Ưu đãi Black Friday',
  shareGift: 'Chia sẻ có quà',
  vipWeeklyWelfare: 'Ưu đãi VIP Tuần',
  exchangeCoupon: 'Đổi phiếu giảm giá',
  firstPayOff: 'Lần đầu mua hưởng 15%OFF cao',
  blackFridayEvent: 'HĐ Black Friday',
  limitedTimeOff: 'Ưu đãi hạn giờ 10%OFF',
  claimCoupon: 'Nhận phiếu giảm giá',
  blackFridayTimedCoupon: 'Phiếu giảm Black Friday',
  timeLeft: 'HĐ còn:',
  claimTimeCoupon: 'Nhận phiếu giảm hạn giờ 10%OFF',
  points: 'Điểm còn: ${point}',
  costPointTip: 'Tiêu hao điểm nhận phiếu giảm mốc ưu đãi bất kỳ',
  maxPointTip: 'Mỗi tài khoản tối đa dùng 500 điểm',
  discountOff: '10%OFF',
  highestDiscount: 'Ưu đãi cao nhất ${discount} ',
  needPoint: 'Cần ${point} điểm',
  changeCurrency: 'Đổi loại tiền',
  claim: 'Nhận',
  claimSucc: 'Nhận thành công',
  claimFail: 'Nhận thất bại',
  pointNotEnough: 'Điểm không đủ',
  afterClaimPoint: 'Điểm sau khi nhận: ${point}',
  footTips1: 'Mỗi giao dịch chỉ được dùng 1 phiếu giảm giá',
  footTips2: 'Khi mua voucher không thể dùng phiếu giảm giá',
  footTips3: 'Quyền giải thích cuối cùng thuộc về đội vận hành',
  ruleTitleText: 'Điều kiện hoạt động',
  ruleTime: 'Thời gian HĐ: 24-11-2023 0:00 ～ 26-11-2023 23:59 (UTC)',
  bfRuleText1:
    '1.Trong HĐ, tài khoản đăng nhập lần đầu trang nạp chính thức nhận 400 điểm, dùng để đổi phiếu giảm giá, tối đa được dùng 500 điểm;',
  bfRuleText2:
    '2.Trong HĐ, dùng điểm Black Friday có thể đổi phiếu giảm giá mốc bất kỳ, mốc ưu đãi càng cao, điểm cần càng nhiều. Sau khi đổi thành công sẽ trừ điểm tương ứng.',
  bfRuleText3:
    '3.Mỗi giao dịch chỉ được dùng 1 phiếu ưu đãi, voucher sản phẩm không thể dùng trong Black Friday',
  bfRuleText4: '4.Phiếu giảm giá Black Day chỉ dùng cho loại tiền sau:',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5.Đổi thành công, không hỗ trợ đổi loại tiền, cũng không hỗ trợ hoàn trả điểm, xin hãy để ý mốc ưu đã và điểm tiêu hao;',
  bfRuleText6: '6.Phiếu giảm giá Black Friday có hiệu lực 7 ngày, hãy để ý dùng;',
  bfRuleText7: '7.Quyền giải thích cuối cùng thuộc về đội vận hành;',
  thanksTip:
    'Cảm ơn bạn đã tham gia, nhiều hoạt động nạp khác vui lòng theo dõi nhóm chính thức',
  exchangePoints: 'Đổi phiếu giảm giá',
  exchangeCode: 'Hãy chọn hình thức thanh toán rồi nhập mã ưu đãi',
  enterExchangeCode: 'Nhập mã ưu đãi tại đây',
  exchangeText: 'Đổi',
  confirmGet: 'Xác nhận nhận',
  couponUsedWay:
    'Phiếu giảm giá chỉ hỗ trợ loại tiền và kênh nạp chỉ định, hãy xác nhận loại tiền bạn muốn dùng',
  confirmText: 'Xác nhận',
  exchangeSucc: 'Đổi thành công',
  aboutCoins: 'Về Voucher',
  aboutCoinsText:
    'Voucher có thể dùng để đổi tất cả gói quà và dịch vụ trong trò chơi trừ voucher',
  known: 'Tôi hiểu rồi',
  codeText: 'Đổi Giftcode',
  codeInvalid: 'Đổi Giftcode vô hiệu!',
  hasExchanged: 'Bạn đã đổi, giftcode chỉ có thể nhận 1 lần!',
  hideText: 'Thu gọn',
  //黑五的报错码
  'bf-20001': 'Chưa đăng nhập',
  'bf-20002': 'Lỗi tham số, hãy thử vào lại hoạt động',
  'bf-20003': 'Điểm không đủ',
  'bf-20004': 'Nhận thất bại, vui lòng thử lại hoặc liên hệ CSKH',
  'bf-20005': 'Đã Nhận',
  'bf-20015': 'HĐ chưa mở, vui lòng chờ đợi',
  'bf-20016': 'HĐ đã kết thúc',
  bfShareText: 'Nhận phiếu giảm hạn giờ 10%OFF',
  rightsCenterBtn: 'Trung Tâm Hội Viên Cao Cấp',
  payBtn: 'Thanh toán',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Vinh Quang Siêu Phàm (Vĩnh viễn)',
  '-': '-'
};
